/* src/app/feature-modules/files-delete-confirmation/files-delete-confirmation.component.css */
/*# sourceMappingURL=files-delete-confirmation.component.css.map */
